<section class="w-full bg-white" [ngClass]="{'border-b-2 border-primary-500': view.site?.id == 79}">
    @if(view.page) {
        <!-- Header image with smooth flowing bottom -->
        <div class="relative w-screen h-[600px] overflow-hidden">
            <!-- Layer 1 -->
            <img [src]="view.imageLayer1" alt="Slideshow Image"
                class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
                [class.opacity-0]="view.activeLayer !== 1" [class.opacity-100]="view.activeLayer === 1" />
    
            <!-- Layer 2 -->
            <img [src]="view.imageLayer2" alt="Slideshow Image"
                class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
                [class.opacity-0]="view.activeLayer !== 2" [class.opacity-100]="view.activeLayer === 2" />
    
            <!-- Flowing wave SVG cut -->
            <svg viewBox="0 0 1440 100" preserveAspectRatio="none" class="absolute bottom-0 left-0 w-full h-[80px] block">
                <path d="M0,0 C360,100 1080,0 1440,80 L1440,100 L0,100 Z" fill="white" />
            </svg>
        </div>
    }

    <div class="container mx-auto sm:px-0 pb-8">
        <div class="flex flex-wrap justify-center dark:bg-slate-800">
            <app-deals-type01 class="bg-white"></app-deals-type01>
        </div>
        <div
            class="flex flex-col sm:flex-row space-y-2.5 sm:space-y-0 sm:space-x-2.5 items-center justify-center ng-star-inserted mt-5">
            <div
                class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg hover:transition-all delay-150 duration-300 ease-in-out">
                <a class="flex-1 font-bold text-xl bg-white px-6 py-3 rounded-xl dark:bg-slate-800"
                    [routerLink]="'/packages'">View all Packages</a>
            </div>
        </div>
    </div>
    @if(view.site?.id != 79) {
        <div class="w-full bg-gray-100">
            <app-counters-type01></app-counters-type01>
        </div>
    }
</section>
